import React, { type ReactNode } from 'react';

import { Footer } from '@shared/ui';

import { Header } from '../header';
import { LayoutContainer } from './layout.styles';

interface Props {
  children: ReactNode;
}

export const Layout = ({ children }: Props) => {
  return (
    <LayoutContainer>
      <Header />
      {children}
      <Footer />
    </LayoutContainer>
  );
};
